import React, { Component } from "react";
import LayoutWrapper from "../LayoutWrapper";
import { Switch, DatePicker, Select, message } from "antd";
import AppTable from "../../../partials/AppTable";
import AddNewIssueModal from "../AddNewIssueModal";
import { ISSUE_STATUS, ISSUE_STATUS_LABELS } from "../schoolinframaintenancetracker";
import "./maintenancequeue.scss";
import schoolmanagementapi from "../../../../api/devapis/schoolmanagementapi";
import issuecategoryapi from "../../../../api/devapis/issuecategoryapi";

const { RangePicker } = DatePicker;
const { Option } = Select;

export class MaintenanceQueue extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct && props.initialconstruct.bind(this)("SchoolInfraMaintenanceTracker");
    this.state = {
      onlySlaBreached: false,
      activeTab: "myBucket", // 'all', 'unassigned', 'myBucket'
      isAddModalVisible: false,
      showFilters: false,
      filterSchool: undefined,
      filterCategory: undefined,
      filterPriority: undefined,
      filterStatus: undefined,
      filterDateRange: null,
      issueList: [],
      categories: [],
      schools: [],
      loading: false,
      total: 0,
      profileId: "",
      priorities: [],
      loadingPriorities: false,
      page: 1,
      limit: 10,
    };
  }

  getAuthHeaders = () => {
    let token =
      window.store?.getState()?.root?.auth ||
      localStorage.getItem("token") ||
      localStorage.getItem("auth") ||
      "";
    if (token) {
      token = token.trim();
      if (!token.toLowerCase().startsWith("bearer ")) {
        token = `Bearer ${token}`;
      }
      return {
        Authorization: token,
        "Content-Type": "application/json",
      };
    }
    return {
      "Content-Type": "application/json",
    };
  };

  getProfileId = async () => {
    if (this.state.profileId) return this.state.profileId;

    try {
      const pd = JSON.parse(localStorage.getItem("profile-data") || "{}");
      if (pd.profile_id) return pd.profile_id;
      if (pd.profileId) return pd.profileId;
      if (pd._id) return pd._id;
    } catch (e) { }

    const user = window.store?.getState()?.root?.user;
    if (user?.profile_id) return user.profile_id;
    if (user?.profileId) return user.profileId;
    if (user?._id) return user._id;

    const directId = localStorage.getItem("profile_id");
    if (directId) return directId;

    // Fetch from /api/v1/profile/me if not found in local store
    const token =
      window.store?.getState()?.root?.auth ||
      localStorage.getItem("token") ||
      localStorage.getItem("auth") ||
      "";
    const apiCall = this.props.api?.apiGetMe || this.api?.apiGetMe || window.app?.props?.api?.apiGetMe;

    if (token && apiCall) {
      try {
        const res = await apiCall();

        const profile = res?.data || res;
        const profileId = profile?.profile_id || profile?.profileId || profile?._id;
        if (profileId) {
          localStorage.setItem("profile_id", profileId);
          this.setState({ profileId });
          return profileId;
        }
      } catch (err) {
        console.warn("Failed to fetch /api/v1/profile/me:", err);
      }
    }
    return "";
  };

  formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  formatDateToYYYYMMDD = (d) => {
    if (!d) return "";
    if (typeof d.format === "function") {
      return d.format("YYYY-MM-DD");
    }
    const date = new Date(d);
    if (isNaN(date.getTime())) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  componentDidMount() {
    const role =
      localStorage.getItem("currentAdminRole") ||
      window.store?.getState()?.root?.user?.role;
    if (role === "SCHOOL_COORDINATOR") {
      window.navigate("/schoolinframaintenancetracker");
      return;
    }

    if (role === "SUPER_ADMIN") {
      this.setState({ activeTab: "all" }, () => {
        this.fetchSchools();
        this.fetchCategories();
        this.fetchPriorities();
        this.getProfileId().then(() => this.fetchIssueList());
      });
      return;
    }

    this.fetchSchools();
    this.fetchCategories();
    this.fetchPriorities();
    this.fetchIssueList();
  }

  fetchSchools = () => {
    let role = localStorage.getItem("currentAdminRole");
    if (role === "SCHOOL_COORDINATOR") return;

    const apiCall = (role === "SUPER_ADMIN" || role === "OPERATION_TEAM") 
      ? (this.props.api?.apiGetAllSchoolLists || window.app?.props?.api?.apiGetAllSchoolLists)
      : (this.props.api?.apiGetAllSchoolList || window.app?.props?.api?.apiGetAllSchoolList);

    if (!apiCall) return;

    apiCall()
      .then(res => {
        let raw = res.data || res || [];
        if (!Array.isArray(raw)) {
          if (raw.data && Array.isArray(raw.data)) raw = raw.data;
          else if (raw.records && Array.isArray(raw.records)) raw = raw.records;
          else raw = [raw];
        }

        let schoolOptions = [];
        if (raw.length > 0 && Array.isArray(raw[0].records)) {
          schoolOptions = raw[0].records.filter(s => s && (s.school_name || s.name)).map(s => ({
            value: s.school_id || s._id || s.school_name || s.name,
            label: s.school_name || s.name
          }));
        } else {
          schoolOptions = raw.filter(s => s && (s.school_name || s.name)).map(s => ({
            value: s.school_id || s._id || s.school_name || s.name,
            label: s.school_name || s.name
          }));
        }

        this.setState({ schools: schoolOptions });
      }).catch(e => console.error("Failed to load schools:", e));
  };

  fetchCategories = () => {
    const apiCall = this.props.api?.apiGetIssueCategories || window.app?.props?.api?.apiGetIssueCategories;
    if (!apiCall) return;

    apiCall()
      .then((res) => {
        let list = [];
        if (res && res.data) {
          list = Array.isArray(res.data)
            ? res.data
            : Array.isArray(res.data.data)
              ? res.data.data
              : [];
        } else if (Array.isArray(res)) {
          list = res;
        }
        if (list.length > 0) {
          this.setState({ categories: list });
        }
      })
      .catch((err) => console.warn("Failed to load categories:", err));
  };

  fetchPriorities = () => {
    this.setState({ loadingPriorities: true });
    const apiCall = this.props.api?.apiGetIssuePriorities || window.app?.props?.api?.apiGetIssuePriorities;
    if (!apiCall) return;

    apiCall()
      .then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          this.setState({ priorities: res.data, loadingPriorities: false });
        } else {
          this.setState({ loadingPriorities: false });
        }
      })
      .catch((err) => {
        console.warn('Failed to load priorities:', err);
        this.setState({ loadingPriorities: false });
      });
  };

  fetchIssueList = async () => {
    this.setState({ loading: true });

    const profileId = await this.getProfileId();
    if (profileId && profileId !== this.state.profileId) {
      this.setState({ profileId });
    }

    const searchObj = {};

    // 1. Tab-based filters
    if (this.state.activeTab === "unassigned") {
      searchObj.showOnlyUnAssigned = true;
    } else if (this.state.activeTab === "myBucket") {
      searchObj.showOnlyUnAssigned = false;
      if (profileId) {
        searchObj.assignTo = profileId;
      }
    } else {
      // 'all'
      searchObj.showOnlyUnAssigned = false;
    }

    // 2. SLA switch
    if (this.state.onlySlaBreached) {
      searchObj.showOnlySLABreached = true;
    } else {
      searchObj.showOnlySLABreached = false;
    }

    // 3. Filter Row options
    if (this.state.filterSchool) {
      searchObj.assignedSchools = [this.state.filterSchool];
    }
    if (this.state.filterCategory) {
      searchObj.categoryId = this.state.filterCategory;
    }
    if (this.state.filterPriority) {
      searchObj.priorityId = this.state.filterPriority;
    }
    if (this.state.filterStatus) {
      searchObj.status = this.state.filterStatus;
    }
    if (this.state.filterDateRange && this.state.filterDateRange.length === 2) {
      const [start, end] = this.state.filterDateRange;
      if (start) searchObj.raisedOnStartDate = this.formatDateToYYYYMMDD(start);
      if (end) searchObj.raisedOnEndDate = this.formatDateToYYYYMMDD(end);
    }

    const payload = {
      limit: this.state.limit || 10,
      order_by: "updatedAt",
      order_direction: "DESC",
      page: this.state.page || 1,
      search: searchObj,
    };

    console.log("MaintenanceQueue POST /api/v1/issue-tracker/issue-list payload:", payload);

    const apiCall =
      this.props.api?.apiGetEducatorIssueList ||
      this.api?.apiGetEducatorIssueList ||
      window.app?.props?.api?.apiGetEducatorIssueList;

    if (apiCall) {
      apiCall(payload)
        .then((res) => {
          this.processIssueListResponse(res);
        })
        .catch(() => {
          this.fetchDirectly(payload);
        });
      return;
    }

    this.fetchDirectly(payload);
  };

  fetchDirectly = (payload) => {
    const apiCall =
      this.props.api?.apiGetEducatorIssueList ||
      window.app?.props?.api?.apiGetEducatorIssueList;
    
    if (apiCall) {
      apiCall(payload).then(res => this.processIssueListResponse(res)).catch((err) => {
        console.error("Fetch issue list error:", err);
        this.setState({ loading: false, issueList: [], total: 0 });
      });
    } else {
      console.warn("apiGetEducatorIssueList is not available");
      this.setState({ loading: false, issueList: [], total: 0 });
    }
  };

  parseIssueRecords = (res) => {
    let records = [];
    let total = 0;

    if (!res) return { records: [], total: 0 };

    const rawData = res.data !== undefined ? res.data : res;

    if (Array.isArray(rawData)) {
      if (
        rawData.length > 0 &&
        rawData[0] &&
        typeof rawData[0] === "object" &&
        (Array.isArray(rawData[0].records) || Array.isArray(rawData[0].pagination))
      ) {
        records = Array.isArray(rawData[0].records) ? rawData[0].records : [];
        total = rawData[0].pagination?.[0]?.totalRecords ?? records.length;
      } else {
        records = rawData;
        total = res.total ?? res.totalCount ?? records.length;
      }
    } else if (rawData && typeof rawData === "object") {
      if (Array.isArray(rawData.records)) {
        records = rawData.records;
        total = rawData.totalCount ?? rawData.total ?? records.length;
      } else if (Array.isArray(rawData.data)) {
        records = rawData.data;
        total = rawData.totalCount ?? rawData.total ?? records.length;
      } else if (Array.isArray(rawData.issues)) {
        records = rawData.issues;
        total = rawData.total ?? records.length;
      } else if (Array.isArray(rawData.list)) {
        records = rawData.list;
        total = rawData.total ?? records.length;
      }
    }

    return { records, total: total || records.length };
  };

  processIssueListResponse = (res) => {
    this.setState({ loading: false });
    const { records, total } = this.parseIssueRecords(res);

    const mapped = (records || []).map((item, idx) => {
      const schoolName =
        item.school?.school_name ||
        item.schoolData?.school_name ||
        item.schoolName ||
        item.school ||
        item.schoolId ||
        "-";

      const categoryName =
        item.issueCategoryData?.name ||
        item.issueCategory?.name ||
        item.categoryName ||
        item.category ||
        "-";

      const priorityVal =
        item.issuePriorityData?.name ||
        item.issuePriorityIdData?.priority ||
        item.priority ||
        "-";

      const rawStatus = String(item.status || "OPEN").trim();
      let statusDisplay = rawStatus;
      const normStatus = rawStatus.toUpperCase().replace(/[\s-_]/g, "");
      if (normStatus === "OPEN") statusDisplay = "Open";
      else if (normStatus.includes("PROGRESS")) statusDisplay = "In Progress";
      else if (normStatus.includes("HOLD")) statusDisplay = "On Hold";
      else if (normStatus.includes("RESOLV")) statusDisplay = "Resolved";
      else if (normStatus.includes("CLOSE")) statusDisplay = "Closed";
      else if (normStatus.includes("CANCEL")) statusDisplay = "Cancelled";

      // Owner should come from assignedTo per user requirement for OPERATION_TEAM
      const ownerVal =
        (typeof item.assignedTo === "object" ? item.assignedTo?.name : null) ||
        item.assignedToData?.name ||
        (item.assignedTo && item.assignedTo !== "N/A" && typeof item.assignedTo === "string" && item.assignedTo.length < 25 ? item.assignedTo : "-");

      const raisedByVal =
        (typeof item.raisedBy === "object" ? item.raisedBy?.name : null) ||
        (Array.isArray(item.raisedByData) ? item.raisedByData[0]?.name : item.raisedByData?.name) ||
        (item.raisedBy && typeof item.raisedBy === "string" && !item.raisedBy.match(/^[0-9a-z]{15,}$/i) ? item.raisedBy : "-");

      const stateVal = item.schoolData?.state || item.school?.state || item.state || "-";
      const cityVal = item.schoolData?.city || item.school?.city || item.city || "-";

      const raisedOnVal = this.formatDate(item.createdAt || item.created_at || item.raisedOn);
      const slaVal = item.slaBreached === true || item.showOnlySLABreached === true || item.sla === true;
      const ageingVal = item.ageing !== undefined && item.ageing !== null ? item.ageing : null;

      let resolvedOnVal = "-";
      if ((normStatus.includes("RESOLV") || normStatus.includes("CLOSE")) && item.updatedAt) {
        resolvedOnVal = this.formatDate(item.updatedAt);
      } else if (item.resolvedOn || item.resolvedAt) {
        resolvedOnVal = this.formatDate(item.resolvedOn || item.resolvedAt);
      }

      return {
        key: item.issueId || item._id || idx,
        issueId: item.issueId || `SIM-${idx + 1}`,
        school: schoolName,
        category: categoryName,
        priority: priorityVal,
        status: statusDisplay,
        owner: ownerVal,
        raisedBy: raisedByVal,
        state: stateVal,
        city: cityVal,
        raisedOn: raisedOnVal,
        sla: slaVal,
        ageing: ageingVal,
        resolvedOn: resolvedOnVal,
        rawItem: item,
      };
    });

    this.setState({
      issueList: mapped,
      total: total || mapped.length,
    });
  };

  getColumns() {
    return [
      {
        dataIndex: "issueId",
        title: "Issue #",
        sorter: false,
        render: (text, record, index) => {
          const page = this.state.page || 1;
          const limit = this.state.limit || 10;
          const num = (page - 1) * limit + index + 1;
          return <span className="fw-semibold text-dark">{num}</span>;
        }
      },
      {
        dataIndex: "school",
        title: "School Name",
        sorter: (a, b) => String(a.school || "").localeCompare(String(b.school || ""))
      },
      {
        dataIndex: "category",
        title: "Category",
        sorter: (a, b) => String(a.category || "").localeCompare(String(b.category || ""))
      },
      {
        dataIndex: "priority",
        title: "Priority",
        sorter: (a, b) => String(a.priority || "").localeCompare(String(b.priority || "")),
        render: (text) => {
          if (!text || text === "-") return <span className="text-muted">-</span>;
          const cls = `badge-priority priority-${String(text).toLowerCase()}`;
          return <span className={cls}>{text}</span>;
        }
      },
      {
        dataIndex: "status",
        title: "Status",
        sorter: (a, b) => String(a.status || "").localeCompare(String(b.status || "")),
        render: (text, record) => {
          const statusKey = String(text || "").toLowerCase().replace(/[\s-_]/g, "");
          return (
            <div className="d-inline-flex align-items-center gap-2">
              <span className={`badge-pill status-${statusKey}`}>{text}</span>
              {record.sla && (
                <span className="sla-alert">
                  <i className="la la-exclamation-triangle"></i> SLA
                </span>
              )}
            </div>
          );
        }
      },
      {
        dataIndex: "owner",
        title: "Owner",
        sorter: (a, b) => String(a.owner || "").localeCompare(String(b.owner || "")),
        render: (text) => (!text || text === "-") ? <span className="text-muted">-</span> : text
      },
      {
        dataIndex: "raisedBy",
        title: "Raised By",
        sorter: (a, b) => String(a.raisedBy || "").localeCompare(String(b.raisedBy || ""))
      },
      {
        dataIndex: "state",
        title: "State",
        sorter: (a, b) => String(a.state || "").localeCompare(String(b.state || ""))
      },
      {
        dataIndex: "city",
        title: "City",
        sorter: (a, b) => String(a.city || "").localeCompare(String(b.city || ""))
      },
      {
        dataIndex: "raisedOn",
        title: "Raised On",
        sorter: (a, b) => String(a.raisedOn || "").localeCompare(String(b.raisedOn || ""))
      },
      {
        dataIndex: "ageing",
        title: "Ageing",
        sorter: (a, b) => (a.ageing || 0) - (b.ageing || 0),
        render: (text, record) => {
          const val = record.ageing;
          return (val !== null && val !== undefined) ? `${val} day${val === 1 || val === 0 ? '' : 's'}` : "-";
        }
      },
      {
        dataIndex: "resolvedOn",
        title: "Resolved On",
        sorter: (a, b) => String(a.resolvedOn || "").localeCompare(String(b.resolvedOn || ""))
      }
    ];
  }

  exportToCSV = async () => {
    try {
      const profileId = await this.getProfileId();
      const searchObj = {};

      if (this.state.activeTab === "unassigned") {
        searchObj.showOnlyUnAssigned = true;
      } else if (this.state.activeTab === "myBucket") {
        searchObj.showOnlyUnAssigned = false;
        if (profileId) {
          searchObj.assignTo = profileId;
        }
      } else {
        searchObj.showOnlyUnAssigned = false;
      }

      searchObj.showOnlySLABreached = !!this.state.onlySlaBreached;

      if (this.state.filterSchool) searchObj.assignedSchools = [this.state.filterSchool];
      if (this.state.filterCategory) searchObj.categoryId = this.state.filterCategory;
      if (this.state.filterPriority) searchObj.priorityId = this.state.filterPriority;
      if (this.state.filterStatus) searchObj.status = this.state.filterStatus;
      if (this.state.filterDateRange && this.state.filterDateRange.length === 2) {
        const [start, end] = this.state.filterDateRange;
        if (start) searchObj.raisedOnStartDate = this.formatDateToYYYYMMDD(start);
        if (end) searchObj.raisedOnEndDate = this.formatDateToYYYYMMDD(end);
      }

      const payload = {
        limit: this.state.total || 1000,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
        search: searchObj,
      };

      const apiCall = this.props.api?.apiExportIssues || this.api?.apiExportIssues || window.app?.props?.api?.apiExportIssues;
      if (!apiCall) {
        throw new Error('API method not found');
      }

      message.loading({ content: 'Exporting...', key: 'exporting' });

      const res = await apiCall(payload);
      if (!res) throw new Error('Export failed');

      const blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `maintenance_queue_export.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      message.success({ content: 'Exported successfully', key: 'exporting' });
    } catch (err) {
      console.error("Failed to export:", err);
      message.error({ content: 'Failed to export issues', key: 'exporting' });
    }
  };

  clearFilters = () => {
    this.setState(
      {
        filterSchool: undefined,
        filterCategory: undefined,
        filterPriority: undefined,
        filterStatus: undefined,
        filterDateRange: null,
        onlySlaBreached: false,
      },
      () => {
        this.fetchIssueList();
      }
    );
  };

  renderFilterRow() {
    if (!this.state.showFilters) return null;
    return (
      <div className="filter-panel p-3 mb-3 bg-light rounded border">
        <div className="row g-3 align-items-end">
          <div className="col-md-2">
            <span className="filter-label">School</span>
            <Select
              placeholder="Select School"
              style={{ width: "100%" }}
              value={this.state.filterSchool}
              onChange={(val) => this.setState({ filterSchool: val, page: 1 }, this.fetchIssueList)}
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {this.state.schools.map((s, i) => (
                <Option key={s.value || i} value={s.value}>
                  {s.label}
                </Option>
              ))}
            </Select>
          </div>
          <div className="col-md-2">
            <span className="filter-label">Category</span>
            <Select
              placeholder="Select Category"
              style={{ width: "100%" }}
              value={this.state.filterCategory}
              onChange={(val) => this.setState({ filterCategory: val, page: 1 }, this.fetchIssueList)}
              allowClear
            >
              {this.state.categories.map((c, i) => (
                <Option key={c.issueCategoryId || c._id || i} value={c.issueCategoryId || c._id}>
                  {c.name || c.category_name}
                </Option>
              ))}
            </Select>
          </div>
          <div className="col-md-2">
            <span className="filter-label">Priority</span>
            <Select
              placeholder="Select Priority"
              style={{ width: "100%" }}
              value={this.state.filterPriority}
              onChange={(val) => this.setState({ filterPriority: val, page: 1 }, this.fetchIssueList)}
              allowClear
              loading={this.state.loadingPriorities}
              showSearch
              optionFilterProp="children"
            >
              {this.state.priorities.map(p => <Option key={p.issuePriorityId} value={p.issuePriorityId}>{p.name}</Option>)}
            </Select>
          </div>
          <div className="col-md-2">
            <span className="filter-label">Status</span>
            <Select
              placeholder="Select Status"
              style={{ width: "100%" }}
              value={this.state.filterStatus}
              onChange={(val) => this.setState({ filterStatus: val, page: 1 }, this.fetchIssueList)}
              allowClear
            >
              <Option value={ISSUE_STATUS.OPEN}>{ISSUE_STATUS_LABELS[ISSUE_STATUS.OPEN]}</Option>
              <Option value={ISSUE_STATUS.INPROGRESS}>{ISSUE_STATUS_LABELS[ISSUE_STATUS.INPROGRESS]}</Option>
              <Option value={ISSUE_STATUS.ONHOLD}>{ISSUE_STATUS_LABELS[ISSUE_STATUS.ONHOLD]}</Option>
              <Option value={ISSUE_STATUS.RESOLVED}>{ISSUE_STATUS_LABELS[ISSUE_STATUS.RESOLVED]}</Option>
              <Option value={ISSUE_STATUS.CLOSED}>{ISSUE_STATUS_LABELS[ISSUE_STATUS.CLOSED]}</Option>
              <Option value={ISSUE_STATUS.CANCELLED}>{ISSUE_STATUS_LABELS[ISSUE_STATUS.CANCELLED]}</Option>
            </Select>
          </div>
          <div className="col-md-3">
            <span className="filter-label">Raised Date Range</span>
            <RangePicker
              style={{ width: "100%" }}
              value={this.state.filterDateRange}
              onChange={(val) => this.setState({ filterDateRange: val, page: 1 }, this.fetchIssueList)}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const role =
      localStorage.getItem("currentAdminRole") ||
      window.store?.getState()?.root?.user?.role;
    const isSuperAdmin = role === "SUPER_ADMIN";

    const headerRight = (
      <div className="d-flex align-items-center gap-4">
        <div className="d-flex align-items-center gap-2">
          <Switch
            checked={this.state.onlySlaBreached}
            onChange={(val) => this.setState({ onlySlaBreached: val, page: 1 }, this.fetchIssueList)}
            style={{ backgroundColor: this.state.onlySlaBreached ? "#fca000" : undefined }}
          />
          <span className="fw-bold text-dark" style={{ fontSize: "14px" }}>
            Show Only SLA Breached Issues
          </span>
        </div>
        <button
          className="btn fw-bold px-4 export-btn"
          onClick={this.exportToCSV}
          style={{ backgroundColor: '#20b263', color: '#fff', border: 'none', borderRadius: '4px' }}
        >
          Export to CSV
        </button>
      </div>
    );

    return (
      <LayoutWrapper title="Maintenance Queue" headerRight={headerRight}>
        <div className="maintenance-queue mt-4">

          {/* Tabs bar and Add Issue section */}
          <div className="queue-action-bar d-flex justify-content-between align-items-center mb-3">
            {!isSuperAdmin ? (
              <div className="queue-tabs d-flex gap-4">
                <button
                  className={`tab-btn ${this.state.activeTab === "all" ? "active" : ""}`}
                  onClick={() => this.setState({ activeTab: "all", page: 1 }, this.fetchIssueList)}
                >
                  All
                </button>
                <button
                  className={`tab-btn ${this.state.activeTab === "unassigned" ? "active" : ""}`}
                  onClick={() => this.setState({ activeTab: "unassigned", page: 1 }, this.fetchIssueList)}
                >
                  Unassigned
                </button>
                <button
                  className={`tab-btn ${this.state.activeTab === "myBucket" ? "active" : ""}`}
                  onClick={() => this.setState({ activeTab: "myBucket", page: 1 }, this.fetchIssueList)}
                >
                  My Bucket
                </button>
              </div>
            ) : (
              <div></div>
            )}

            <div className="d-flex align-items-center gap-3">
              <button
                className="btn-filter d-flex align-items-center gap-1 text-dark"
                onClick={() => this.setState({ showFilters: !this.state.showFilters })}
              >
                <i className="la la-filter"></i>
                <span className="fw-bold">Filters</span>
                <i className={`la la-angle-${this.state.showFilters ? "up" : "down"}`}></i>
              </button>
              <button
                className="btn-clear-filter text-danger fw-bold"
                onClick={this.clearFilters}
              >
                Clear Filter
              </button>
              <button
                className="btn-add-issue d-flex align-items-center gap-1"
                onClick={() => this.setState({ isAddModalVisible: true })}
              >
                <i className="la la-plus"></i> Add Issue
              </button>
            </div>
          </div>

          {this.renderFilterRow()}

          {/* Table section */}
          <div className="table-card">
            <div className="table-responsive">
              <AppTable
                data={this.state.issueList}
                columns={this.getColumns()}
                total={this.state.total}
                loading={this.state.loading}
                onChange={(pagination) => {
                  this.setState({
                    page: pagination.current,
                    limit: pagination.pageSize
                  }, this.fetchIssueList);
                }}

                editable={true}
                deletable={false}
                viewable={true}
                isresponsive={true}
                reorder={true}
                targetType="tap"
                editAction={(record) => {
                  const id = record.rawItem?.issueId || record.issueId;
                  window.navigate(`/schoolinframaintenancetracker/editmaintenancequeue?id=${id}&mode=edit`);
                }}
                viewAction={(record) => {
                  const id = record.rawItem?.issueId || record.issueId;
                  window.navigate(`/schoolinframaintenancetracker/editmaintenancequeue?id=${id}&mode=view`);
                }}
              />
            </div>
          </div>
        </div>

        <AddNewIssueModal
          visible={this.state.isAddModalVisible}
          onCancel={() => this.setState({ isAddModalVisible: false })}
          onSuccess={() => {
            this.setState({ isAddModalVisible: false });
            this.fetchIssueList();
          }}
          api={this.props.api}
          store={this.props.store}
        />
      </LayoutWrapper>
    );
  }
}

export default connect(MaintenanceQueue);
